import { PointOfSale } from './point-of-sale';

// Modalità con cui è gestita la privacy policy lato configurazione (backend).
export enum PrivacyPolicyModeEnum {
  Paste = 0,
  Template = 1,
  Link = 2,
}

export interface Company {
  logo: string;
  name: string;
  address: string;
  postalCode: string;
  city: string;
  region: string;
  vatCode: string;
  telephone?: string;
  fax?: string;
  email?: string;
  pec?: string;
  cookiePolicy?: string;
  privacyPolicy?: string;
  privacyNotice?: string;
  // Determina come gestire il link alla privacy policy nel footer.
  privacyPolicyMode?: PrivacyPolicyModeEnum;
  // URL esterno della privacy policy, valorizzato solo quando mode è Link.
  privacyPolicyUrl?: string | null;
  slogan?: string;
  urlSito?: string;
  urlFacebook?: string;
  numberPointOfSales: number;
  isGoogleMapsActive: boolean;
  isGoogleMapsSearchActive: boolean;
  sameDayAppointment: boolean;
  autoConfirmation: boolean;
  pointOfSale?: PointOfSale;
  webSiteLink?: string;
  MinCancellationValue: number;
  maxBookingValue: number;
  isUserSelectable: boolean;
  whatsappNumber?: string | null;
  googleAnalyticsId?: string | null;
  metaPixelId?: string | null;
  // Smart multi-store: il backend lo restituisce già risolto (flag dell'insegna, azienda
  // FOCUS CLOUD e più di un centro ottico). Assente o false = comportamento precedente.
  isSmartMultiStoreActive?: boolean;
  [x: string]: any;
}
